/** DB comment_reaction_tipo uses `jaja`; UI historically used `haha` */
export const COMMENT_REACTION_TO_UI = {
  like: 'like',
  love: 'love',
  jaja: 'haha',
  mate: 'mate',
  mano: 'mano',
};

export const COMMENT_REACTION_TO_DB = {
  like: 'like',
  love: 'love',
  haha: 'jaja',
  jaja: 'jaja',
  mate: 'mate',
  mano: 'mano',
};

export function mapCommentFromDb(row) {
  if (!row) return null;
  return {
    id: row.id,
    item_id: row.commentable_id,
    item_type: row.commentable_type,
    member_id: row.member_id,
    text: row.contenido,
    created_at: row.created_at,
  };
}

export function mapReactionFromDb(row) {
  if (!row) return null;
  return {
    id: row.id,
    item_id: row.reactable_id,
    item_type: row.reactable_type,
    member_id: row.member_id,
    created_at: row.created_at,
  };
}

export function mapCommentReactionFromDb(row) {
  if (!row) return null;
  return {
    id: row.id,
    comment_id: row.comment_id,
    member_id: row.member_id,
    type: COMMENT_REACTION_TO_UI[row.tipo] || row.tipo,
    created_at: row.created_at,
  };
}

export function commentReactionToDb(type) {
  return COMMENT_REACTION_TO_DB[type] || type;
}
